export const FETCH_COMPANIES = "FETCH_COMPANIES";
export const FETCH_COMPANY = "FETCH_COMPANY";
export const CREATE_COMPANY = "CREATE_COMPANY";
export const UPDATE_COMPANY = "UPDATE_COMPANY";
export const DELETE_COMPANY = "DELETE_COMPANY";
export const FETCH_COMPANY_SMSRELOADS = "FETCH_COMPANY_SMSRELOADS";
export const FETCH_COMPANY_SMSRELOAD = "FETCH_COMPANY_SMSRELOAD";
export const ADD_COMPANY_SMSRELOAD = "ADD_COMPANY_SMSRELOAD";
export const UPDATE_COMPANY_SMSRELOAD = "UPDATE_COMPANY_SMSRELOAD";
export const DELETE_COMPANY_SMSRELOAD = "DELETE_COMPANY_SMSRELOAD";

export function fetchCompanies(params = {}) {
  params = Object.assign(
    {},
    { partials: "articles", orderBy: "id:desc" },
    params
  );
  return {
    type: FETCH_COMPANIES,
    auth: true,
    payload: {
      url: "superuser/companies",
      method: "GET",
      params
    }
  };
}

export function fetchCompany(id, params = {}) {
  params = Object.assign(
    {},
    { partials: "photos|user|paymentGateways|users?roleSlug=administrator" },
    params
  );
  return {
    type: FETCH_COMPANY,
    auth: true,
    payload: {
      url: `superuser/companies/${id}`,
      method: "GET",
      params
    }
  };
}

export function createCompany(data = {}) {
  return {
    type: CREATE_COMPANY,
    auth: true,
    payload: {
      url: "superuser/companies",
      method: "POST",
      data
    }
  };
}

export function updateCompany(id, data = {}) {
  return {
    type: UPDATE_COMPANY,
    auth: true,
    payload: {
      url: `superuser/companies/${id}`,
      method: "PUT",
      data
    }
  };
}

export function deleteCompany(id, data = {}) {
  return {
    type: DELETE_COMPANY,
    auth: true,
    payload: {
      url: `superuser/companies/${id}`,
      method: "DELETE",
      data
    }
  };
}

export function fetchSmsReloads(id, params = {}) {
  params = Object.assign({}, { orderBy: "id:desc" }, params);
  return {
    type: FETCH_COMPANY_SMSRELOADS,
    auth: true,
    payload: {
      url: `superuser/companies/${id}/sms-reloads`,
      method: "GET",
      params
    }
  };
}

export function fetchSmsReload(companyId, id, params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_COMPANY_SMSRELOAD,
    auth: true,
    payload: {
      url: `superuser/companies/${companyId}/sms-reloads/${id}`,
      method: "GET",
      params
    }
  };
}

export function addSmsReload(id, data = {}) {
  return {
    type: ADD_COMPANY_SMSRELOAD,
    auth: true,
    payload: {
      url: `superuser/companies/${id}/sms-reloads`,
      method: "POST",
      data
    }
  };
}

export function updateSmsReload(companyId, id, data = {}) {
  return {
    type: UPDATE_COMPANY_SMSRELOAD,
    auth: true,
    payload: {
      url: `superuser/companies/${companyId}/sms-reloads/${id}`,
      method: "PUT",
      data
    }
  };
}

export function deleteSmsReload(companyId, id, data = {}) {
  return {
    type: DELETE_COMPANY_SMSRELOAD,
    auth: true,
    payload: {
      url: `superuser/companies/${companyId}/sms-reloads/${id}`,
      method: "DELETE",
      data
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/company.js